import { cn } from '../../lib/utils';

/**
 * Surface primitive. `interactive` adds the lift-on-hover treatment used by
 * feature, plan and step cards — kept in one place so the elevation, border
 * and timing stay identical everywhere.
 */
export default function Card({
  as: Component = 'div',
  interactive = false,
  highlighted = false,
  className,
  children,
  ...props
}) {
  return (
    <Component
      className={cn(
        'relative rounded-2xl border bg-surface-raised/60 shadow-card',
        highlighted
          ? 'border-line-brand bg-brand/[0.06]'
          : 'border-line',
        interactive &&
          'transition-[transform,border-color,background-color,box-shadow] duration-300 ease-smooth hover:-translate-y-1 hover:border-line-strong hover:bg-surface-raised hover:shadow-raised',
        interactive && highlighted && 'hover:border-brand/50',
        className,
      )}
      {...props}
    >
      {children}
    </Component>
  );
}
